<pr-transaction-display
  *ngFor="let display of displays$ | async; trackBy: trackByDisplay"
  [invoice]="invoice$ | async"
  [claim]="claim$ | async"
  [transactionDisplay]="display"
>
  <ng-content></ng-content>
</pr-transaction-display>

